export class UserModel {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  id: string;

  constructor(data: UserModel) {
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.email = data.email;
    this.id = data.id;
    this.phoneNumber = data.phoneNumber;
  }
}
